import { css } from 'emotion';
import {
	museo900,
	grey,
	lightGrey,
	darkGrey,
	mobileMaxWidthBreakpoint,
} from 'inside-out/global-styles';
import RememberPromptBG from './bg.svg';

export const wrapperStyle = css({
	boxShadow: 'rgba(0,0,0,0.12) 0 6px 22px 0',
	padding: '18px 14px',
	borderRadius: '6px',
	border: `1px solid ${lightGrey}`,
	background: `#fff url(${RememberPromptBG}) no-repeat 110% 170%`,
	width: '276px',
	height: '180px',
	boxSizing: 'border-box',
	'& h1': {
		...museo900,
		fontSize: '16px',
		lineHeight: '19px',
		color: darkGrey,
		margin: '0 0 9px 0',
		fontWeight: 'normal',
	},
	'& p': {
		color: grey,
		fontSize: '14px',
		lineHeight: '18px',
		margin: '0 0 14px 0',
	},
	'& a': {
		padding: '9px 10px',
		width: '100%',
		textAlign: 'center',
	},
	position: 'fixed',
	bottom: '24px',
	right: '24px',
	zIndex: '99999',
	[`@media(max-width: ${mobileMaxWidthBreakpoint}px)`]: {
		borderRadius: '0',
		boxShadow: 'rgba(0,0,0,0.05) 0 -3px 4px 0',
		bottom: '0',
		right: 'auto',
		left: '0',
		width: '100%',
		height: '94px',
		background: '#fff',
		padding: '11px 10px',
		'& h1': {
			fontSize: '14px',
			lineHeight: '17px',
		},
		'& p': {
			display: 'none',
		},
	},
});



// WEBPACK FOOTER //
// ./src/components/shared/rememberPrompt/styles.js